/*!
 */

;(function ( $, window, document, undefined ) {

    var pluginName = 'beContentPackage',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.url = $(element).attr('data-url');
        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;
        Plugin.setEvents();
    };

    Plugin.prototype.setEvents = function () {
        var Plugin = this;

        $('.js-url').on('click', function(){
            var completo = true;
            var url = Plugin.url + '/content-preview?';

            $('.js-url-preview').each(function () {
                if ($(this).val()!='' && $(this).val()!= null) {
                    url += $(this).attr('name')+'='+$(this).val()+'&'
                }else{
                    completo = false;
                }
            });
            if(completo){
                window.open(url, '_blank');
            }
        })

    };




    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );/**
 * Created by miguelgonzalez on 8/11/17.
 */
/**
 * Created by miguelgonzalez on 13/11/17.
 */
